module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Regular.aaeac71d.otf";